import { AuthHttp } from '../http.ts'
import { isSuiteSsoRedirectMode } from '../sso/sso-flags'
import { resolvePayAccessTokenForMicroservices } from '../sso/services/pay-auth-bridge.service'

const PREFIX = '/auth'
const headers = {
  'Content-type': 'application/json'
}

export const authApiHealthCheck = () => {
  return AuthHttp.get(`${PREFIX}/health-check`, {
    headers
  })
}

// export const login = (username: string, password: string, cipherText: string, iv: string) => {
//   return AuthHttp.post(
//     `${PREFIX}/login`,
//     { username, password, cipherText, iv },
//     {
//       headers
//     }
//   )
// }

export const login = (cipherText: string, iv: string) => {
  return AuthHttp.post(
    `${PREFIX}/login`,
    { cipherText, iv },
    {
      headers
    }
  )
}

export const requestRecoveryPasswordCode = (systemUserEmail: string, systemUserLanguage: string) => {
  return AuthHttp.post(
    `${PREFIX}/request-recovery-password-code`,
    { systemUserEmail, systemUserLanguage },
    {
      headers
    }
  )
}

/**
 * Exchanges a Pay refresh JWT for a short-lived RS256 access token.
 * In SSO mode without Pay refresh token, bridges via Identity → /auth/request-access-token.
 */
export const requestAccessToken = async (refreshToken: string) => {
  const normalized = refreshToken?.replaceAll('"', '').trim() ?? ''

  if (isSuiteSsoRedirectMode() && !normalized) {
    const accessToken = await resolvePayAccessTokenForMicroservices()
    return { data: { accessToken } }
  }

  return AuthHttp.post(
    `${PREFIX}/request-access-token`,
    {},
    {
      headers: {
        ...headers,
        Authorization: `Bearer ${refreshToken}`
      }
    }
  )
}

export const validateRecoveryPasswordCode = (systemUserRecoveryPasswordCode: string, otpCodeAuthToken: string) => {
  return AuthHttp.post(
    `${PREFIX}/validate-recovery-password-code`,
    { systemUserRecoveryPasswordCode },
    {
      headers: {
        ...headers,
        Authorization: `Bearer ${otpCodeAuthToken}`
      }
    }
  )
}

export const recoverSystemUserPassword = (systemUserPassword: string, authToken: string) => {
  return AuthHttp.post(
    `${PREFIX}/recover-system-user-password`,
    { systemUserPassword },
    {
      headers: {
        ...headers,
        Authorization: `Bearer ${authToken}`
      }
    }
  )
}

export const enableTwoFactorAuth = (otpCodeToCheck: string, authToken: string) => {
  return AuthHttp.post(
    `${PREFIX}/enable-two-factor-auth`,
    { otpCodeToCheck },
    {
      headers: {
        ...headers,
        Authorization: `Bearer ${authToken}`
      }
    }
  )
}

export const checkTwoFactorAuth = (otpCodeToCheck: string, authToken: string) => {
  return AuthHttp.post(
    `${PREFIX}/check-two-factor-auth`,
    { otpCodeToCheck },
    {
      headers: {
        ...headers,
        Authorization: `Bearer ${authToken}`
      }
    }
  )
}

export const getLocalDbSecret = (accessToken: string) => {
  return AuthHttp.get(`${PREFIX}/local-db-secret`, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}
